import "./i18n/i18n";
import "./index.css";

import type { JSX } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { RouterProvider } from "react-router-dom";

import { router } from "./app/router";
import { GlobalAccessibilityEffects } from "./Components/GlobalAccessibilityEffects";
import { useGlobalAuthSync } from "./hooks/useGlobalAuthSync";
import { initTheme } from "./store/theme";

export default function App(): JSX.Element {
  useGlobalAuthSync(); // Sync auth state across tabs
  const dispatch = useDispatch();

  /**
   * Initialize theme ONCE when app loads.
   * This safely applies:
   * - theme1
   * - theme2
   */
  useEffect(() => {
    dispatch<any>(initTheme());
  }, [dispatch]);

  return (
    <>
      {/* Global accessibility & cursor features */}
      <GlobalAccessibilityEffects />

      {/* App routing */}
      <RouterProvider router={router} />
    </>
  );
}
